import { render, staticRenderFns } from "./TeacherCertificates.vue?vue&type=template&id=51e3216e&"
import script from "./TeacherCertificates.vue?vue&type=script&lang=js&"
export * from "./TeacherCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports